export default __webpack_public_path__ + "images/de6d955e06b3d5a52df0f5b456f68b73-accord-texto.svg";